<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
      <h2>{{formData ? "Update Product" : "Add Body Part"}}</h2>
      <div class="flex-container gap-2">
        <div class="dialog-btn" (click)="onClose()">
          <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
        </div>
      </div>
    </div>
    <form #f="ngForm" name="form" novalidate>
      <div class="dialog-content-block p-3">
        <div class="w-100 mt-4">
          <div class="flex-column">
            <div class="form-group">  
              <div class="cabinet-dropdown stores">
                <h6 class="text-start text-dark">Type</h6>
                <div class="w-100">
                  <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isDropDownType.set(!isDropDownType())">
                    <span>{{ changedStoreType.type }}</span>
                    <img src="../../../assets/images/dropdown.png" [class]="isDropDownType() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                  </span>
                  <ul class="dropdown-menu dropdown-content" [class]="isDropDownType() ? 'd-block' : ''">
                    <li *ngFor="let type of type" class="dropdown-item" (click)="onTypeChange(type)">{{ type.type }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-column mt-3">
            <div class="form-group">
              <h6 class="text-start text-dark">Name</h6>
              <input type="text" name="product_code" [(ngModel)]="nameTxt" value="">
              <div class="form-error-msg"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" (click)="onClose()">Cancel</button>
        <button class="primary-btn addproduct" type="submit" (click)="onAdd()">{{ formData ? "Update" : "Add" }}</button>
      </div>
    </form>
  </div>
  